import { cn } from '@/utils/classnames';
import { useTheme } from 'next-themes';
import { resolveRole, roleMetaMap } from '@/constants/role-colors';

export default function RoleBadge({ role, className, showDot = true }: { role?: string | null; className?: string; showDot?: boolean }) {
  const { resolvedTheme } = useTheme();
  const meta = resolveRole(role);
  const config = meta ? roleMetaMap[meta.code] : undefined;
  if (!config) return <span className={cn('text-second', className)}>{role || '—'}</span>;
  const isDark = resolvedTheme === 'dark';
  const color = isDark ? config.darkColor : config.color;
  return <span className={cn('inline-flex h-[2.4rem] w-fit items-center gap-[0.6rem] rounded-[0.8rem] border px-[0.8rem] text-[1.2rem] font-medium leading-none', className)} style={{ color, backgroundColor: isDark ? config.bgDark : config.bgLight, borderColor: isDark ? config.borderDark : config.border }}>
    {showDot && <span className="h-[0.7rem] w-[0.7rem] shrink-0 rounded-full" style={{ backgroundColor: color }} aria-hidden="true" />}
    {config.label}
  </span>;
}
